import { render } from "./SupportModal.vue?vue&type=template&id=b24fbf6c&scoped=true"
import script from "./SupportModal.vue?vue&type=script&lang=js"
export * from "./SupportModal.vue?vue&type=script&lang=js"

import "./SupportModal.vue?vue&type=style&index=0&id=b24fbf6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24fbf6c"]])

export default __exports__